/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { put, select, takeLatest } from 'redux-saga/effects'
import { resetState } from '../../patientDemographics/store/patientDemographics.actions'
import { resetPatientAllergiesState } from '../../patientAllergies/store/patientAllergies.actions'
import { resetPatientMedicalHistoryState } from '../../patientMedicalHistory/store/patientMedicalHistory.actions'
import { resetPatientMedicationsState } from '../../patientMedications/store/patientMedications.actions'
import { clearFilters, resetTimelineState } from '../../timeline/store/timeline.actions'
import { resetPatientVitalsState } from '../../vitals/store/vitals.actions'
import { resetTimesState } from '../../times/store/times.actions'
import { resetQuickActionState } from '../../quickActions/store/quickActions.actions'
import { resetTripInformationState } from '../../tripInformation/store/tripInformation.actions'
import { resetPickupAddressState } from '../../pickupAddress/store/pickupAddress.actions'
import { resetSignaturesState } from '../../signatures/store/signatures.actions'
import { getSignaturesSelector } from '../../signatures/selectors/getSignatures.selector'
import { ISignaturesState } from '../../signatures/store/signatures.types'
import { revokeAllSignatureUrls } from '../../../utilities/signature.util'
import { resetSubmitChartState } from '../../submitChart/store/submitChart.actions'
import { resetNarrativeState } from '../../narrative/store/narrative.actions'
import { resetCadImportState } from '../../cadImport/store/cadImport.actions'
import {
  resetCardiacArrestState,
  resetCcHpiInjuryDetails,
  resetHistoryState,
  resetSituationState,
} from '../../ccHpi/store/ccHpi.actions'
import { resetSearchState } from '../../../components/search/store/search.actions'
import { resetInsuredOptions, resetPatientAllergiesOptions } from '../../options/store/options.actions'
import { HomeConstants } from '../store/home.constants'
import { resetDispositionState } from '../../destinationAddress/store/destinationAddress.actions'
import { resetInsuranceInformationState } from '../../insuranceInformation/store/insuranceInformation.actions'
import { resetRelationshipsAndGuarantorsState } from '../../relationshipsAndGuarantors/store/relationshipsAndGuarantors.action'
import { resetPCSInformationState } from '../../pcsInformation/store/pcsInformation.actions'
import { resetAuthorizationInformationState } from '../../authorizationInformation/store/authorizationInformation.actions'
import { resetCmsInformationState } from '../../cmsInformation/store/cmsInformation.actions'
import { resetPaymentInformation } from '../../paymentInformation/store/paymentInformation.actions'
import { resetPatientInformationState } from '../../patientInformation/store/patientInformation.actions'
import { resetPatientImmunizations } from '../../patientImmunizations/store/patientImmunizations.actions'
import { resetSearchState as resetPatientSearchState } from '../../patientSearch/store/patientSearch.actions'
import { resetPcrError } from '../../pcr/store/pcr.actions'
import { resetCustomSignature } from '../../customSignature/store/customSignature.actions'
import { resetFactorsAffectingCareState } from '../../factorsAffectingCare/store/factorsAffectingCare.actions'
import { resetCameraAttachmentsState } from '../../cameraAttachments/store/cameraAttachments.actions'
import { resetSceneDescriptionState } from '../../sceneDescription/store/sceneDescription.actions'
import { resetInitialAssessmentAirway } from '../../initialAssessments/airway/store/airway.actions'
import { resetRespiratoryState } from '../../initialAssessments/respiratory/store/respiratory.actions'
import { resetPupilsState } from '../../initialAssessments/neuro/pupils/store/pupils.actions'
import { resetMotorSensoryState } from '../../initialAssessments/neuro/motorSensoryAssessment/store/motoSensoryAssessment.actions'
import { resetNeuroState } from '../../initialAssessments/neuro/store/neuro.actions'
import { resetWasPatientImmobilized } from '../../initialAssessments/neuro/wasPatientImmobilized/store/wasPatientImmobilized.actions'
import { resetGlassgowCommaScoreData } from '../../initialAssessments/neuro/glassgowCommaScore/store/glassgowCommaScore.actions'
import { resetRTSData } from '../../initialAssessments/neuro/revisedTraumaScore/store/revisedTraumaScore.actions'
import { resetPtsData } from '../../initialAssessments/neuro/pediatricTraumaScore/store/pediatricTraumaScore.actions'
import { resetPulsesState } from '../../initialAssessments/cardio/pulses/store/pulses.actions'
import { resetInitialAssessmentCardioState } from '../../initialAssessments/cardio/store/cardio.actions'
import { resetExposure } from '../../exposure/store/exposure.actions'
import { resetEmployerState } from '../../patientDemographics/employer/store/employer.actions'
import { resetMotorVehicleIncident } from '../../ccHpi/motorVehicleIncident/store/motorVehicleIncident.actions'
import { resetEKGAfterLeavingChart } from '../../ekgImport/store/ekgImport.actions'
import { resetDiagnosisState } from '../../diagnosis/store/diagnosis.actions'
import { resetDrainsAndTubes } from '../../additionalAssessments/bodyAssessment/drainsTubes/store/drainsAndTubes.actions'
import { resetObstetrics } from '../../additionalAssessments/bodyAssessment/obstetrics/store/obstetrics.actions'
import { resetCommentsState } from '../../../components/commentSection/store/comments.actions'
import { resetBurns } from '../../additionalAssessments/bodyAssessment/burns/store/burns.actions'
import { resetBodySurvey } from '../../additionalAssessments/bodyAssessment/bodySurvey/store/bodySurvey.actions'
import { resetAssessments } from '../../additionalAssessments/store/additionalAssessments.actions'
import { resetLocationSearchState } from '../../locationSearch/store/locationSearch.actions'
import { clearSelectedPCR, resetHomeState } from '../store/home.actions'
import { resetRulesState } from '../../rules/store/rules.actions'
import { resetDocumentScannerState } from '../../documentScanner/store/documentScanner.actions'
import { resetNemsisCustomData } from '../../nemsisData/store/nemsisCustomData.actions'
import { resetSignerData } from '../../completeChart/store/completeChart.actions'
import { resetSpecialReportsOnChartExit } from '../../specialReports/store/specialReports.actions'
import { resetFluidsState } from '../../fluids/store/fluids.actions'
import { resetFillablePDFsOnChartExit } from '../../fillablePDFs/store/fillablePDFs.actions'
import { resetPulsara } from '../../pulsara/store/pulsara.actions'
import { resetNotificationCenterState } from '../../notificationCenter/store/notificationCenter.actions'
import { resetQaAddendumState } from '../../qaFlags/qaAddendums/store/qaAddendum.actions'
import { resetPcrBackupMetadata } from '../../pcrBackup/store/pcrBackup.actions'
import { resetState as resetIntubationState } from '../../intubation/store/intubation.actions'
import { resetState as resetAddMedicationAdministeredState } from '../../addMedicationAdministered/store/addMedicationAdministered.actions'
import { resetState as resetAirwayProcedureState } from '../../procedures/airway/store/airway.actions'
import { resetState as resetAssessmentProcedureState } from '../../procedures/assessment/store/assessment.actions'
import { resetState as resetBloodProductAdministrationProcedureState } from '../../procedures/bloodProductAdministration/store/bloodProductAdministration.actions'
import { resetState as resetCardiacProcedureState } from '../../procedures/cardiac/store/cardiac.actions'
import { resetState as resetChildbirthOBProcedureState } from '../../procedures/childbirthOB/store/childbirthOB.actions'
import { resetState as resetCriticalCareProcedureState } from '../../procedures/criticalCare/store/criticalCare.actions'
import { resetState as resetDrainProcedureState } from '../../procedures/drain/store/drain.actions'
import { resetState as resetExtricationProcedureState } from '../../procedures/extrication/store/extrication.actions'
import { resetState as resetHospitalNotifyProcedureState } from '../../procedures/hospitalNotify/store/hospitalNotify.actions'
import { resetState as resetImagingUltrasoundProcedureState } from '../../procedures/imagingUltrasound/store/ImagingUltrasound.actions'
import { resetState as resetImmobilizationProcedureState } from '../../procedures/immobilization/store/immobilization.actions'
import { resetState as resetInitiateIvProcedureState } from '../../procedures/initiateIv/store/initiateIv.actions'
import { resetState as resetMedicalConsultProcedureState } from '../../procedures/medicalConsult/store/medicalConsult.actions'
import { resetState as resetOperationsProcedureState } from '../../procedures/operations/store/operations.actions'
import { resetState as resetPnProcedureState } from '../../procedures/pnProcedure/store/pnProcedure.actions'
import { resetState as resetRescueProcedureState } from '../../procedures/rescue/store/rescue.actions'
import { resetState as resetVentricularAssistDeviceProcedureState } from '../../procedures/ventricularAssistDevice/store/ventricularAssistDevice.actions'
import { resetState as resetVentilatorProcedureState } from '../../procedures/ventilator/store/ventilator.actions'
import { resetState as resetWoundCareProcedureState } from '../../procedures/woundCare/store/woundCare.actions'

export function* resetPCRState() {
  const signaturesState: ISignaturesState = yield select(getSignaturesSelector)
  yield put(clearSelectedPCR())
  yield put(resetState())
  yield put(resetEmployerState())
  yield put(resetAuthorizationInformationState())
  yield put(resetTimesState())
  yield put(resetPatientMedicationsState())
  yield put(resetPatientAllergiesState())
  yield put(resetPatientMedicalHistoryState())
  yield put(resetPatientVitalsState())
  yield put(resetTripInformationState())
  yield put(clearFilters())
  yield put(resetQuickActionState())
  yield put(resetPickupAddressState())
  revokeAllSignatureUrls(signaturesState)
  yield put(resetSignaturesState())
  yield put(resetSubmitChartState())
  yield put(resetNarrativeState())
  yield put(resetCadImportState())
  yield put(resetSituationState())
  yield put(resetHistoryState())
  yield put(resetCardiacArrestState())
  yield put(resetCcHpiInjuryDetails())
  yield put(resetSearchState())
  yield put(resetPatientAllergiesOptions())
  yield put(resetDispositionState())
  yield put(resetInsuranceInformationState())
  yield put(resetRelationshipsAndGuarantorsState())
  yield put(resetPCSInformationState())
  yield put(resetCmsInformationState())
  yield put(resetPaymentInformation())
  yield put(resetPatientSearchState())
  yield put(resetEKGAfterLeavingChart())
  yield put(resetTimelineState())
  yield put(resetAirwayProcedureState())
  yield put(resetAssessmentProcedureState())
  yield put(resetBloodProductAdministrationProcedureState())
  yield put(resetCardiacProcedureState())
  yield put(resetChildbirthOBProcedureState())
  yield put(resetCriticalCareProcedureState())
  yield put(resetDrainProcedureState())
  yield put(resetExtricationProcedureState())
  yield put(resetHospitalNotifyProcedureState())
  yield put(resetImagingUltrasoundProcedureState())
  yield put(resetImmobilizationProcedureState())
  yield put(resetInitiateIvProcedureState())
  yield put(resetMedicalConsultProcedureState())
  yield put(resetOperationsProcedureState())
  yield put(resetPnProcedureState())
  yield put(resetRescueProcedureState())
  yield put(resetVentricularAssistDeviceProcedureState())
  yield put(resetVentilatorProcedureState())
  yield put(resetWoundCareProcedureState())
  yield put(resetIntubationState())
  yield put(resetAddMedicationAdministeredState())
  yield put(resetPatientInformationState())
  yield put(resetPatientImmunizations())
  yield put(resetInsuredOptions())
  yield put(resetPcrError())
  yield put(resetCustomSignature())
  yield put(resetFactorsAffectingCareState())
  yield put(resetCameraAttachmentsState())
  yield put(resetSceneDescriptionState())
  yield put(resetExposure())
  yield put(resetInitialAssessmentAirway())
  yield put(resetRespiratoryState())
  yield put(resetPupilsState())
  yield put(resetMotorSensoryState())
  yield put(resetNeuroState())
  yield put(resetWasPatientImmobilized())
  yield put(resetGlassgowCommaScoreData())
  yield put(resetRTSData())
  yield put(resetPtsData())
  yield put(resetPulsesState())
  yield put(resetInitialAssessmentCardioState())
  yield put(resetMotorVehicleIncident())
  yield put(resetDiagnosisState())
  yield put(resetDrainsAndTubes())
  yield put(resetObstetrics())
  yield put(resetCommentsState())
  yield put(resetBurns())
  yield put(resetBodySurvey())
  yield put(resetAssessments())
  yield put(resetLocationSearchState())
  yield put(resetRulesState())
  yield put(resetDocumentScannerState())
  yield put(resetSpecialReportsOnChartExit())
  yield put(resetHomeState())
  yield put(resetNemsisCustomData())
  yield put(resetSignerData())
  yield put(resetFluidsState())
  yield put(resetFillablePDFsOnChartExit())
  yield put(resetPulsara())
  yield put(resetNotificationCenterState())
  yield put(resetQaAddendumState())
  yield put(resetPcrBackupMetadata())
}

export function* resetPCRSaga() {
  yield takeLatest([HomeConstants.RESET_PCR], resetPCRState)
}
